export enum PaymentTransactionStatuses {
  Pending = 'Pending',
  ReadyForPayment = 'ReadyForPayment',
  Active = 'Active',
  Completed = 'Completed',
}
